
import React from 'react';
import DeviceHealthDashboard from '@/components/WaterDeviceHealthDashboard';
import CompactLayout from '@/components/layout/CompactLayout';
import { Toaster } from '@/components/ui/toaster';

const WaterDeviceHealth = () => {
  return (
    <CompactLayout>
      <div className="h-[calc(100vh-4rem)] overflow-hidden">
        <DeviceHealthDashboard />
      </div>
      <Toaster />
    </CompactLayout>
  );
};

export default WaterDeviceHealth;
